import { getTaskFilters } from '@dispatch/shared/services';
import { useQuery } from '../useQuery';
export const useGetTaskFilters = (userId: string) => {
  const { data, status, refetch } = useQuery(['task-filters', userId], () =>
    getTaskFilters(userId)
  );

  return {
    storedFilters: data,
    storedFiltersStatus: status,
    fetchStoredFilters: refetch,
  };
};
